import { render, staticRenderFns } from "./WUserAutocomplete.vue?vue&type=template&id=54bfb4d4&scoped=true&"
import script from "./WUserAutocomplete.vue?vue&type=script&lang=js&"
export * from "./WUserAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bfb4d4",
  null
  
)

export default component.exports